module.exports = __webpack_public_path__ + "static/invoice_template.b7d0b3cd.png";